
<template>
    <div class="customervendor-container">
        <ThatsTable title="Warehouse Setup" ref="table" :endpoint="endpoint" @openModal="openWindow" @deleteYes="DispatchDelete" @openUpdateModal="OpenUpdateModal" :columns="columns"></ThatsTable>
        <WarehouseForm ref="dialogForm" @success="refreshTable" @delete="formDelete"></WarehouseForm>
    </div>
</template>
<script>
import { mapGetters, mapMutations,mapActions } from 'vuex';
import WarehouseForm from './WarehouseForm'
import ThatsTable from '../../components/thats/Table'
export default {
    data(){
        return {
            endpoint : 'warehouse/data'
        }
    },
    components: {
        WarehouseForm,
        ThatsTable
    },

    methods: {
        ...mapActions('WarehouseModule',[ 'DeleteRecord' ]),
        ...mapMutations('WarehouseModule',[ 'SetFormRecord', 'SetFormStatusUpdate']),

        formDelete(record){
            const items = [];
            items.push(record.row);
            this.DispatchDelete(items);
        },
        DispatchDelete(items){
            var self = this;
            self.DeleteRecord(items).then((response) => {
                self.$ThatsNotify.success({
                    message : `(${response.deleted}) record was successfully deleted.`
                })
               self.refreshTable();
            })

        },
        OpenUpdateModal(obj){
            this.SetFormStatusUpdate()
            this.SetFormRecord(obj)
            this.openWindow()
        },
        openWindow(){
            this.$refs.dialogForm.openDialog()
        },
        closeWindow(){
            this.$refs.dialogForm.closeDialog()
        },
        refreshTable(){
            this.$refs.table.refreshTable()
        }
    },
    computed: {
        ...mapGetters('WarehouseModule',[ 'data', 'page', 'total', 'page', 'length', 'columns', 'Loading', ]),
    },
}
</script>
<style scoped>
.container {
    position: relative;
    min-height: 340px;
  }
  .placement {
    position: absolute;
    right: 0;
  }
</style>